var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-info card m-2"},[_c('div',{staticClass:"count-text fs-1 mb-2"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-primary font-weight-bold fs-5"},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }